'use strict';

import {getLogger, levels} from 'loglevel';
const log = getLogger('performance');

export function checkRunSpeedPerformance(testName, warnMilliseconds, errorMilliseconds, fn, context = this) {
  return function() {
    let t;
    let tEnd;
    if (log.getLevel() <= levels.DEBUG) t = performance.now();
    const returnValue = fn.apply(context, arguments);
    if (t) {
      tEnd = performance.now();
      let tStart = (t - (performance.timing.domContentLoadedEventStart - performance.timing.navigationStart)).toFixed(2);
      let tDiff = tEnd - t;
      if (tDiff > errorMilliseconds) {
        log.error(`Performance too slow: ${testName} > ${warnMilliseconds}ms:${tDiff.toFixed(2)}ms @${tStart}ms`, fn, arguments);
      } else if (tDiff > warnMilliseconds) {
        log.warn(`Can performance be improved? ${testName} > ${warnMilliseconds}ms:${tDiff.toFixed(2)}ms @${tStart}ms`, fn, arguments);
      } else if (log.getLevel() === levels.TRACE) {
        log.warn(`${testName} speed is: ${tDiff.toFixed(2)}ms @${tStart}ms`, fn, arguments);
      }
    }
    return returnValue;
  }
}




// WEBPACK FOOTER //
// ./uikit/utilities/performanceHelpers.js